import map from "./map.js";
import layer from "./layer.js";
import style from "./style.js";

import { getArea, getLength } from "ol/sphere.js";

/**
 * Format length output.
 * @param {module:ol/geom/LineString~LineString} line The line.
 * @return {string} The formatted length.
 */
const formatLength = function(line) {
  const length = getLength(line);
  let output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + " " + "km";
  } else {
    output = Math.round(length * 100) / 100 + " " + "m";
  }
  return output;
};

/**
 * Format area output.
 * @param {module:ol/geom/Polygon~Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */
const formatArea = function(polygon) {
  const area = getArea(polygon);
  let output;
  if (area > 10000) {
    output = Math.round((area / 1000000) * 100) / 100 + " " + "km<sup>2</sup>";
  } else {
    output = Math.round(area * 100) / 100 + " " + "m<sup>2</sup>";
  }
  return output;
};

const findBootstrapEnvironment = () => {
  let envs = ["xs", "sm", "md", "lg", "xl"];

  let el = document.createElement("div");
  document.body.appendChild(el);

  let curEnv = envs.shift();

  for (let env of envs.reverse()) {
    el.classList.add(`d-${env}-none`);

    if (window.getComputedStyle(el).display === "none") {
      curEnv = env;
      break;
    }
  }

  document.body.removeChild(el);
  return curEnv;
};

const isMobile = () => {
  return ["xs", "sm"].indexOf(findBootstrapEnvironment()) !== -1;
};

const getNearestZoom = scale => {
  return Math.log(scale) / Math.log(2);
};

const getNearestScale = zoom => {
  return Math.pow(2, zoom);
};

export {
  map,
  layer,
  style,
  formatLength,
  formatArea,
  findBootstrapEnvironment,
  isMobile,
  getNearestZoom,
  getNearestScale
};
